import { clearSessionExpiredFlag, setStoredSession, STORAGE_KEY } from './sessionStorage';
import type { QueryClient } from '@tanstack/react-query';

type ClearClientStateOptions = {
  preserveSessionStorageKey?: boolean;
};

export const clearAuthClientState = (
  queryClient: QueryClient,
  options?: ClearClientStateOptions,
): void => {
  const preserveSessionStorageKey = options?.preserveSessionStorageKey ?? false;
  const preserveLocalStorageKeys = new Set(['flowqa-theme-mode']);

  if (preserveSessionStorageKey) {
    preserveLocalStorageKeys.add(STORAGE_KEY);
  }

  const shouldRemoveLocalStorageKey = (key: string): boolean => {
    if (preserveLocalStorageKeys.has(key)) {
      return false;
    }

    return key.startsWith('flowqa-') || key.startsWith('datagrid:');
  };

  if (typeof window !== 'undefined') {
    try {
      const keys: string[] = [];
      for (let index = 0; index < window.localStorage.length; index += 1) {
        const key = window.localStorage.key(index);
        if (key && shouldRemoveLocalStorageKey(key)) {
          keys.push(key);
        }
      }
      keys.forEach((key) => {
        window.localStorage.removeItem(key);
      });
    } catch {
      // ignore storage failures
    }

    try {
      window.sessionStorage.clear();
    } catch {
      // ignore storage failures
    }
  }

  clearSessionExpiredFlag();
  if (!preserveSessionStorageKey) {
    setStoredSession(null);
  }
  void queryClient.cancelQueries();
  queryClient.clear();
};
